module.exports = __webpack_public_path__ + "media/map/ON_Icon-ceac1389.png";